<template>
  <div>
    <div class="page-title-box">
      <div class="page-title-right">
        <permission name="PricelistUpdate">
          <button type="button" class="btn btn-primary btn-sm" @click="gotoEdit">
            <i class="mdi mdi-pencil"></i> Muuda
          </button>
        </permission>
      </div>
      <h4 class="page-title">Üldine hinnakiri</h4>
    </div>

    <div class="card">

      <div class="card-body bg-light py-2">
        <b-form-checkbox v-model="showServicesWithoutPrice" :value="true" :unchecked-value="false">
          Näita hinnastamata teenuseid
        </b-form-checkbox>
      </div>

      <div class="card-body">
        <table class="table table-sm table-vertical-centered table-sticky table-hover mb-0">
          <thead class="thead">
            <tr>
              <th>Teenus</th>
              <th class="text-right" width="20%">KM %</th>
              <th class="text-right" width="20%">Üldhind &euro;</th>
            </tr>
          </thead>
          <tbody>

          <template v-for="(item, index) in data">
            <tr v-if="showServicesWithoutPrice || item.price || item.vat">
              <td>{{item.serviceName}}</td>
              <td width="20%" class="text-right p-0 px-1">
                {{item.vat}}
              </td>
              <td width="20%" class="text-right p-0 px-1">
                {{item.price}}
              </td>
            </tr>
          </template>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'

  export default {
    data() {
      return {
        showServicesWithoutPrice: false,
        data: []
      }
    },
    methods: {
      sortByServiceNameAsc(data) {
        data.sort((a, b) => {
          if (a.serviceName < b.serviceName) return -1;
          if (a.serviceName === b.serviceName) return 0;
          return 1;
        })
      },
      gotoEdit() {
        this.$router.push('/pricelist/edit')
      }
    },
    created() {
      gateway.get(`/pricelist`).then(r => {
        this.data = r.data
        this.sortByServiceNameAsc(this.data)
      })
    }
  }
</script>
